<template>
  <div class="wr-sjz">
    <!-- 填写驳回原因弹窗 -->
    <el-dialog :visible.sync="visible"
               :close-on-click-modal='false'
               :before-close="cancelAdd"
               title="驳回原因"
               width="800px">
      <el-form :model="dataForm"
               :inline="true"
               ref="dataForm"
               label-width="160px"
               class="demo-form-inline">
        <el-row>
          <el-col :span="24">
            <el-form-item label="请填写驳回原因："
                          prop="userName">
              <label>
                <el-input type="textarea"
                          v-model="dataForm.remarkReason"
                          placeholder="请填写驳回信息(不超过200字)..."
                          maxlength="200"
                          style="width:550px !important"
                          :rows="4"></el-input>
              </label>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="btns">
          <el-button class="btn-check-cancel"
                     @click="cancelAdd()"
                     :class="subLoading?'but-loading':''">取消</el-button>
          <el-button type="primary"
                     class="btn-check"
                     @click="handleCancel()"
                     :class="subLoading?'but-loading':''">确认驳回</el-button>
        </div>
      </el-form>
    </el-dialog>
    <div class="container">
      <!-- 面包屑 -->
      <Breadcrumb :pageTitle="pageTitle" />
      <!-- <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('basicInfo')">个人中心</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareStatementList')">联储联备</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('spareStatementList')">对账单</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item">对账单详情</div>
      </div> -->
      <div style="width:100%;height:140px">
        <div style="float:left;width:35%;height:135px;background:white;padding-top:40px"
             class="formtitle">
          <el-form :model="dataForm"
                   :inline="true"
                   ref="dataForm"
                   class="demo-form-inline">
            <el-row class="row-height">
              <el-col :span="17"
                      class="row-height">
                <el-form-item label="对账单号:"
                              label-width="140px">
                  <label style="font-weight:bold;font-size:16px">{{ detailInfo.accountBillNo }}</label>
                </el-form-item>
              </el-col>
              <el-col :span="7"
                      class="row-height">
                <el-form-item label=" "
                              label-width="10px">
                  <div style="font-weight:bold;background:#EDF4FF;margin-top:-18px;width:110px;height:35px;border:2px solid #63B6FF;line-height:35px;text-align:center;border-radius:3px">
                    <label style="font-size:20px;color:#63B6FF"
                           v-if="activeIndex === 0">账期生成</label>
                    <label style="font-size:20px;color:#63B6FF"
                           v-if="activeIndex === 1">确认账单</label>
                    <label style="font-size:20px;color:#63B6FF"
                           v-if="activeIndex === 2">账单支付</label>
                    <label style="font-size:20px;color:#63B6FF"
                           v-if="activeIndex === 4">对账完成</label>
                    <label style="font-size:20px;color:#63B6FF"
                           v-if="activeIndex === 5">对账评价</label>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="sjz">
          <div :class="index===(steps.length-1)?'sjz-item':'sjz-kuaikuai'"
               v-for="(item, index) in steps"
               :key="index">
            <div class="sjz-item">
              <div :class="'sjz-icon '+ ((index === activeIndex) ? 'sjz-doing' : ((index > activeIndex) ? 'sjz-done' : ''))">
                <i class="el-icon-check"
                   style="width:40px;height:40px;"
                   v-if="index<activeIndex"></i>
                <span class="sjc-num sjc-do"
                      v-else-if="index===activeIndex">{{index+1}}</span>
                <span class="sjc-num"
                      v-else-if="index>activeIndex">{{index+1}}</span>
              </div>
              <div :class="'word-icon '+ ((index === activeIndex) ? 'word-do' : ((index > activeIndex) ? 'word-undone' : ''))">{{item.name}}</div>
            </div>
            <div :class="'sjz-line '+((index>=activeIndex)?'sjz-undone':'')"
                 v-if="index!==(steps.length-1)"></div>
          </div>
        </div>
      </div>
      <div class="body-info">
        <div style="height:35px;width:100%">
          <div style="float:left;font-size:18px;font-weight:bold">对账单详情</div>
          <div class="row-height"
               style="float:right">
            <el-button type="primary"
                       size="medium"
                       @click="pingjiaclick"
                       v-if="activeIndex === 4 || activeIndex === 5"
                       icon="el-icon-edit">评价</el-button>
          </div>
        </div>
        <el-form :model="dataForm"
                 :inline="true"
                 ref="dataForm"
                 label-width="180px"
                 class="demo-form-inline"
                 v-if="detailInfo">
          <div style="background:#F5F7FA">
            <el-row>
              <el-col :span="12"
                      class="row-height">
                <el-form-item label="对账单号："
                              prop="userName">
                  <label>{{detailInfo.accountBillNo}}</label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12"
                      class="row-height">
                <el-form-item label="公司名称："
                              prop="userCompany">
                  <label>{{ detailInfo.companyName }}</label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12"
                      class="row-height">
                <el-form-item label="客户负责人：">
                  <label>{{detailInfo.customerLeaderName}}</label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12"
                      class="row-height">
                <el-form-item label="联系电话：">
                  <label>{{ detailInfo.customerLeaderMobile }}</label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12"
                      class="row-height">
                <el-form-item label="对账单生效日期：">
                  <label>{{detailInfo.effectiveDate}}</label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12"
                      class="row-height">
                <el-form-item>
                  <span slot="label">账期到期日期
                    <el-tooltip class="item"
                                placement="top">
                      <div slot="content"
                           class="tooltip-content"
                           style="max-width: 500px; text-align: left; border-color:#fff;">
                        账期到期未完成付款，将限制备件领用业务！
                      </div>
                      <i class="el-icon-info"
                         style="color:#e6a23c;margin-left:2px;"></i>
                    </el-tooltip>：
                  </span>
                  <label>{{ detailInfo.dueDate}}</label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="detailInfo.remark"
                    style="margin-top:12px">
              <el-col :span="24">
                <el-form-item label="备注：">
                  <label>
                    <el-input type="textarea"
                              v-model="detailInfo.remark"
                              :disabled="true"
                              style="width:600px !important;"
                              :rows="5"></el-input>
                  </label>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="detailInfo && detailInfo.recordList">
              <el-col :span="24">
                <el-form-item label="驳回原因："
                              prop="userMobile">
                  <label>
                    <ul v-if="(detailInfo.recordList && detailInfo.recordList.length > 0)">
                      <li style="width:750px"
                          v-for="data in detailInfo.recordList"
                          :key="data.recordId">{{data.content}}</li>
                    </ul>
                  </label>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <h3 style="display: inline-block;margin-top:20px;font-size:18px;font-weight:bold"
              class="spareInfo">备件领用物品</h3>
          <div class="tabletitle">
            <div style="width:55%">备件领用单详情</div>
            <div style="width:15%">总金额</div>
            <div style="width:15%">单位</div>
            <div style="width:15%">数量</div>
          </div>
          <div v-for="item in dataList"
               style="box-sizing: border-box;"
               :key="item.orderId">
            <div style="box-sizing: border-box;width:100%;height:50px;background: #FFFFFF;border: 1px solid #EEEEEE;line-height:49px;padding-left:20px">
              <span style="box-sizing: border-box;float:left"><span style="color:#999999">{{ item.receiveDate }}</span></span>
              <span style="box-sizing: border-box;float:left;margin-left:30px"><span style="color:#999999">备件领用单号：</span><span style="color:#333333">{{ item.orderCode }}</span></span>
            </div>
            <div style="box-sizing: border-box;width:100%;background: #FFFFFF;border: 1px solid #EEEEEE;padding-left:20px;border-top:none;"
                 :style="{ height: item.details.length * 90 + 'px' }">
              <div style="box-sizing: border-box;width:100%;float:left;height:90px">
                <div v-for="that in item.details"
                     style="width:100%;height:90px;"
                     :key=that.billId>
                  <div style="width:10%;padding-left:10px;float:left;">
                    <img :src="that.goodsUrl"
                         alt=""
                         style="width:100px;height:70px;margin-top:10px">
                  </div>
                  <div style="padding-left:10px;float:left;height:90px;width:45%">
                    <div style="float:left;margin-left:20px;font-weight:bold">
                      <div style="margin-top:25px">{{that.oldBrand}} {{that.oldGoodsName}} {{that.oldGoodsCode}}</div>
                      <div>规格型号：{{that.oldSpecification}} {{that.oldModel}}</div>
                    </div>
                  </div>
                  <div style="box-sizing: border-box;width:15%;float:left;height:90px;line-height:89px">
                    <span style="font-weight:bold;font-size:16px;margin-left:10px">￥</span><span style="font-weight:bold;font-size:16px;color:#D40000">{{Number(that.arAmount).toFixed(2)}}</span>
                  </div>
                  <div style="font-weight:bold;box-sizing: border-box;width:15%;float:left;height:90px;line-height:89px;padding-left:20px;font-size:16px">
                    {{that.sellingUnit || '-'}}
                  </div>
                  <div style="font-weight:bold;box-sizing: border-box;width:15%;float:left;height:90px;line-height:89px;padding-left:20px;font-size:16px">
                    {{that.goodsNum}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tablefoot"
               style="background:#eee;margin-top:0;text-align: right;">
            <span style="margin-right:150px">共计：<span style="color:red">{{allnum}}</span> 件</span>
            <span style="margin-right:50px">合计：<span style="color:red">{{alltotal}}</span>元</span>
          </div>
          <h3 style="display: inline-block;font-size:18px;font-weight:bold"
              class="spareInfo">对账支付记录</h3>
          <el-row style="margin-bottom:10px;">
            <el-table :data="paidList"
                      border
                      v-loading="dataListLoading"
                      style="width: 100%;">
              <el-table-column prop="paidType"
                               header-align="center"
                               align="center"
                               label="支付方式">
              </el-table-column>
              <el-table-column prop="paidAmount"
                               header-align="center"
                               align="center"
                               label="付款金额">
              </el-table-column>
              <el-table-column prop="paidTime"
                               header-align="center"
                               align="center"
                               label="付款时间">
              </el-table-column>
              <el-table-column prop="paymentSerial"
                               header-align="center"
                               align="center"
                               label="付款流水号">
              </el-table-column>
              <el-table-column prop="status"
                               header-align="center"
                               align="center"
                               label="付款状态">
              </el-table-column>
              <el-table-column prop="remark"
                               header-align="center"
                               align="center"
                               label="备注">
              </el-table-column>
            </el-table>
          </el-row>
          <!-- <h3 style="display: inline-block;font-size:18px;font-weight:bold"
              class="spareInfo">附件</h3>
          <el-row>
            <el-col :span="24">
              <el-form-item>
                <ul v-if="detailInfo.ossRelations"
                    class="inquiryfj">
                  <li class="pointer"
                      v-for="(item, index) in detailInfo.ossRelations"
                      :key="index">
                    <div @click="download(item.objectName)">
                      <img v-if="item.fileType === 'docx'"
                           src="../../../../assets/img/word.png">
                      <img v-else-if="item.fileType === 'doc'"
                           src="../../../../assets/img/word.png">
                      <img v-else-if="item.fileType === 'zip'"
                           src="../../../../assets/img/zip.png">
                      <img v-else-if="item.fileType === 'xls'"
                           src="../../../../assets/img/excel.png">
                      <img v-else-if="item.fileType === 'xlsx'"
                           src="../../../../assets/img/excel.png">
                      <img v-else-if="item.fileType === 'pdf'"
                           src="../../../../assets/img/pdf.jpg">
                      <img v-else-if="item.fileType === 'ppt'"
                           src="../../../../assets/img/ppt.png">
                      <img v-else-if="item.fileType === 'pptx'"
                           src="../../../../assets/img/ppt.png">
                      <img v-else-if="item.fileType === 'bmp' || item.fileType === 'jpg' || item.fileType === 'png' || item.fileType === 'gif' || item.fileType === 'BMG' || item.fileType === 'JPG' || item.fileType === 'PNG' || item.fileType === 'GIF'"
                           :src="item.objectName">
                      <img v-else
                           src="../../../../assets/img/zwtp.png"
                           alt="其他">
                      <p class="overell">{{item.fileName + '.' + item.fileType}}</p>
                    </div>
                  </li>
                </ul>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- // 对账单状态(10，20 账期生成、30，31 确认、40 支付、50 完成) 2020.09.01 modify-->
          <!-- 10 待审核、20 待客户确认、31 驳回待确认、30 待付款、40 付款中、50 已付款 -->
          <div class="row"
               style="display:flex;justify-content: center;margin-top:20px">
            <!-- <div v-if="detailInfo.status === 20"
                 :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="margin-right:10px;margin-left:10px;"
                 @click="handleReject()">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              驳回
            </div>
            <div v-if="detailInfo.status === 20"
                 :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="background-color:#1D65A8;color:#fff"
                 @click="handleSave()">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              确认对账单
            </div>
            <div v-if="detailInfo.status === 30"
                 :class="'row-opt-but ' +(subLoading?'but-loading':'')"
                 style="background-color:#1D65A8;color:#fff"
                 @click="handlePay()">
              <i class="el-icon-loading"
                 v-if="subLoading"></i>
              确认支付
            </div> -->
            <el-button @click="handleSave()"
                       v-if="detailInfo.status === 20"
                       style="color:white;background:#1492FF">确认对账单</el-button>
            <el-button @click="handleReject()"
                       v-if="detailInfo.status === 20"
                       style="color:#1492FF;border-color:#1492FF">驳回</el-button>
            <el-button @click="handlePay()"
                       v-if="detailInfo.status === 30"
                       style="color:white;background:#1492FF">确认支付</el-button>
          </div>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
        </span>
      </div>
    </div>
    <el-dialog :visible.sync="searchVisiblefuwu"
               :close-on-click-modal='false'
               :before-close="cancelGoods"
               title="评价"
               width="1120px">
      <div class="box-shadow">
        <div class="right-content"
             style="width:1050px">
          <div class="commnet-top">
            <div class="comment-left">
              <img src="../../../../../public/img/4_03.png" />
              <p class="com-one com-new">{{$t('evaluate.title')}}</p>
              <!-- <p class="com-two">请为本次服务做出评价</p> -->
            </div>
            <div class="comment-right">
              <div style="display:flex;">
                <span class="row-item-label comment-row">{{$t('evaluate.quality')}}</span>
                <label class="row-item-conent">
                  <el-rate class="rate-choose"
                           :disabled="activeIndex === 5"
                           v-model="detailInfo.signVo.serviceQuality"></el-rate>
                </label>
              </div>
              <div style="display:flex;">
                <span class="row-item-label comment-row">{{$t('evaluate.speed')}}</span>
                <label class="row-item-conent">
                  <el-rate class="rate-choose"
                           :disabled="activeIndex === 5"
                           v-model="detailInfo.signVo.serviceResponse"></el-rate>
                </label>
              </div>
              <div style="display:flex;">
                <span class="row-item-label comment-row">{{$t('evaluate.easier')}}</span>
                <label class="row-item-conent">
                  <el-rate class="rate-choose"
                           :disabled="activeIndex === 5"
                           v-model="detailInfo.signVo.serviceFacilitate"></el-rate>
                </label>
              </div>
            </div>
          </div>
          <div class="comment-bottom">
            <div class="bottom-left">{{$t('evaluate.feedback')}}：</div>
            <div class="bottom-right">
              <label class="row-item-conent"
                     style="max-width:880px; width:880px;">
                <el-input type="textarea"
                          :maxlength="200"
                          :disabled="activeIndex === 5"
                          :autosize="{ minRows: 4}"
                          :placeholder="$t('evaluate.placeholder')"
                          v-model="detailInfo.signVo.feedbackContent"></el-input>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div style="width:100%;margin-top:15px;height:40px">
        <el-button style="float:right"
                   :loading="subLoading"
                   @click="cancelGoods()">{{$t('cancel')}}</el-button>
        <el-button type="primary"
                   :loading="subLoading"
                   v-if="activeIndex === 4 || activeIndex === 5"
                   style="float:right;margin-right:10px"
                   @click="saveGoods()">{{$t('confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// const OSS = require('ali-oss')
import Breadcrumb from '@/components/breadcrumb/index'
export default {
  components: {
    Breadcrumb
  },
  data () {
    return {
      // 面包屑
      pageTitle: [
        {
          label: this.$t('header.homepage'),
          url: '/'
        },
        {
          label: this.$t('header.storeSpare'),
          url: '/storeSpare'
        },
        {
          label: this.$t('header.reconciliationSettlement'),
          url: '/spareStatementList'
        },
        {
          label: this.$t('header.reconciliationSettlementDetail')
        }
      ],
      detailInfo: null,
      userInfo: null,
      action: false,
      dataForm: {
        id: '',
        remark: '',
        remarkReason: '' // 驳回原因
      },
      actionUrl: `${window.SITE_CONFIG['forumURL']}/alioss/sysossali/aliOssUploadAttachment`,
      addressId: '',
      addressList: [],
      receivablesList: [],
      gogo: true,
      visible: false,
      dataList: [],
      dataListLoading: false,
      dataListSelections: [],
      subLoading: false, // 按钮加载中
      subFlag: false, // 提交成功
      // 上传下载
      fileListC: [], // 上传组件初始化数据
      fileListS: [], // 要提交的数据
      delUrls: [],
      // oss参数
      bucketName: '',
      accessKeyId: '',
      accessKeySecret: '',
      stsToken: '',
      activeIndex: 0,
      searchVisiblefuwu: false,
      steps: [
        {
          ind: 1,
          key: '',
          name: '账期生成',
          time: ''
        },
        {
          ind: 2,
          key: '',
          name: '确认账单',
          time: ''
        },
        {
          ind: 3,
          key: '',
          name: '账单支付',
          time: ''
        },
        {
          ind: 4,
          key: '',
          name: '对账完成',
          time: ''
        },
        {
          ind: 5,
          key: '',
          name: '对账评价',
          time: ''
        }
      ],
      paidList: [], // 付款记录
      arAmount: 0, // 应付金额
      allnum: 0,
      alltotal: 0
    }
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
        return {
          rowspan: 3,
          colspan: 1
        }
      }
    },
    saveGoods () {
      if (this.subLoading) {
        return false
      }
      if (!this.detailInfo.signVo.feedbackContent) {
        this.$message.warning('评价内容不能为空')
        return false
      }
      this.subLoading = true
      var form = {
        serviceQuality: this.detailInfo.signVo.serviceQuality * 2,
        serviceFacilitate: this.detailInfo.signVo.serviceFacilitate * 2,
        serviceResponse: this.detailInfo.signVo.serviceResponse * 2,
        feedbackContent: this.detailInfo.signVo.feedbackContent,
        billId: this.detailInfo.billId
      }
      this.$http.post(`/front/order/lclb/accountbill/custSign`,
        form
      ).then(({ data: res }) => {
        if (res.code === 0) {
          this.$message.success('评价成功')
          this.searchVisiblefuwu = false
          this.getInfo()
        }
        this.subLoading = false
      }).catch(() => {
        this.subLoading = false
      })
    },
    cancelGoods () {
      this.searchVisiblefuwu = false
    },
    pingjiaclick () {
      this.$http
        .get(
          `/front/order/lclb/accountbill/info/${this.$route.query.id}`
        )
        .then(({ data: res }) => {
          if (!res.data.signVo) {
            this.detailInfo.signVo = {
              serviceQuality: 5,
              serviceFacilitate: 5,
              serviceResponse: 5,
              feedbackContent: ''
            }
          } else {
            this.detailInfo.signVo.serviceFacilitate =
              this.detailInfo.signVo.serviceFacilitate ? this.detailInfo.signVo.serviceFacilitate / 2 : 0
            this.detailInfo.signVo.serviceQuality =
              this.detailInfo.signVo.serviceQuality ? this.detailInfo.signVo.serviceQuality / 2 : 0
            this.detailInfo.signVo.serviceResponse =
              this.detailInfo.signVo.serviceResponse ? this.detailInfo.signVo.serviceResponse / 2 : 0
          }
        })
      this.searchVisiblefuwu = true
    },
    removeHandle (file, index) {
      this.$http
        .post(
          `${window.SITE_CONFIG['forumURL']}/alioss/sysossali/deleteAliOss/${file.id}`
        )
        .then((item) => {
          this.fileListS.splice(index, 1)
          this.detailInfo.voucherOssRelations.splice(index, 1)
        })
        .catch(() => { })
    },
    // 获取当前登录信息
    getUserInfo () {
      this.$http
        .get(`${window.SITE_CONFIG['baseURL']}/sys/user/info`)
        .then((data) => {
          // console.log(data)
          if (data && data.code === '1') {
            this.userInfo = data.result.user
          }
        })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/front/order/lclb/accountbill/info/${this.$route.query.id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.detailInfo = res.data
            this.dataList = res.data.detailList
            if (res.data.arAmount) {
              this.arAmount = res.data.arAmount
            }
            for (let i = 0; i < this.dataList.length; i++) {
              if (this.dataList[i].details) {
                for (let y = 0; y < this.dataList[i].details.length; y++) {
                  this.allnum = this.allnum + this.dataList[i].details[y].goodsNum
                  this.alltotal = this.alltotal + this.dataList[i].details[y].arAmount
                }
              }
            }
            if (!res.data.signVo) {
              this.detailInfo.signVo = {
                serviceQuality: 5,
                serviceFacilitate: 5,
                serviceResponse: 5,
                feedbackContent: ''
              }
            } else {
              this.detailInfo.signVo.serviceFacilitate =
                this.detailInfo.signVo.serviceFacilitate ? this.detailInfo.signVo.serviceFacilitate / 2 : 0
              this.detailInfo.signVo.serviceQuality =
                this.detailInfo.signVo.serviceQuality ? this.detailInfo.signVo.serviceQuality / 2 : 0
              this.detailInfo.signVo.serviceResponse =
                this.detailInfo.signVo.serviceResponse ? this.detailInfo.signVo.serviceResponse / 2 : 0
            }
            this.dataForm.remark = res.data.remark
            if (
              res.data.paidList &&
              res.data.paidList.length > 0
            ) {
              this.paidList = res.data.paidList
            }
            // 对账单状态(10 20 账期生成、30  31确认、40 支付、50 完成、60 评价) 2020.09.01 modif
            if (
              res.data.status === 10 ||
              res.data.status === 20
            ) {
              this.activeIndex = 0
            } else if (
              res.data.status === 30 ||
              res.data.status === 31
            ) {
              this.activeIndex = 1
            } else if (res.data.status === 40) {
              this.activeIndex = 2
            } else if (res.data.status === 50) {
              this.activeIndex = 4
            } else if (res.data.status === 60) {
              this.activeIndex = 5
            }
            if (res.data.effectiveDate) {
              this.steps[0].time = res.data.effectiveDate
            }
            if (res.data.confirmDate) {
              this.steps[1].time = res.data.confirmDate
            }
            if (res.data.payingDate) {
              this.steps[2].time = res.data.payingDate
            }
            if (res.data.finishDate) {
              this.steps[3].time = res.data.finishDate
            }
            if (res.data.voucherOssRelations) {
              this.fileListS = res.data.voucherOssRelations.map(
                (item) => {
                  return {
                    name: item.fileName,
                    percentage: 100,
                    status: 'success',
                    uid: '',
                    url: item.objectName,
                    ossId: item.id
                  }
                }
              )
            }
            if (res.data.effectiveDate) {
              this.detailInfo.effectiveDate = res.data.effectiveDate.substring(
                0,
                10
              )
            }
            if (res.data.dueDate) {
              this.detailInfo.dueDate = res.data.dueDate.substring(
                0,
                10
              )
            }
          }
        })
    },
    // 跳转页面,取消返回
    routerHandle (name, pName) {
      if (name) {
        // if (name === 'spareStatementList'){
        //    this.$router.push({name:'spareStatementList'})
        // } else {
        this.$router.push({ name: name })
        // }
      } else {
        this.resetData()
        this.$router.go(-1)
      }
    },
    // 下载文档
    download (item) {
      var a = document.createElement('a')
      a.href = item
      a.setAttribute('href', a.href)
      a.setAttribute('target', '_blank')
      a.click()
      // document.body.removeChild(a)
    },
    deleteHandle (row, index) {
      this.dataList.splice(index, 1)
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      )
    },
    // 上传附件
    handleRemove (file, fileList) {
      // console.log(file, fileList)
    },
    // 删除文件
    removeFile (file, fileList) {
      if (this.subLoading) {
        return false
      }
      if (file.ossId && file.save) {
        let index = this.fileListS.findIndex((item) => {
          return item.ossId === file.ossId
        })
        if (index > -1) {
          this.delUrls.push(this.fileListS[index].ossId)
          this.fileListS.splice(index, 1)
        }
      } else if (file.uid) {
        let index = this.fileListS.findIndex((item) => {
          return item.uid === file.uid
        })
        if (index > -1) {
          this.$http
            .post(
              `${window.SITE_CONFIG['forumURL']}/alioss/sysossali/deleteAliOss/${this.fileListS[index].ossId}`
            )
            .then((item) => {
              this.fileListS.splice(index, 1)
              this.detailInfo.voucherOssRelations.splice(index, 1)
            })
            .catch(() => { })
        }
      }
    },
    beforeUpload (file) {
      if (this.subLoading) {
        return false
      }
      let newName = file.name.slice(0, file.name.lastIndexOf('.'))
      let regx = /^[\u4E00-\u9FA5A-Za-z0-9]+$/
      if (regx.test(newName)) {
      } else {
        this.$message.warning(
          '文件名只能由数字、英文字母、汉字组成，不能有空格 + 《 》等特殊符号'
        )
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 100
      if (!isLt2M) {
        this.$message.error('上传的附件不得大于100MB')
      }
      return isLt2M
    },
    // 上传成功
    successFile (response, file, fileList) {
      // console.log(response, file, fileList)
      let ossId = response.result.data.id
      let filename = response.result.data.fileName
      let objNew = {
        createDate: null,
        fileName: file.name.split('.')[0],
        fileSize: '',
        fileType: file.name.split('.')[1],
        id: ossId,
        objectName: file.url,
        status: false,
        svgName: '',
        type: ''
      }
      this.fileListS.push({
        uid: file.uid,
        ossId: ossId,
        ossName: file.url,
        name: filename
        // uploadId: checkpoint.uploadId
      })
      this.detailInfo.voucherOssRelations.push(objNew)
    },
    // 上传失败
    errorFile (file, fileList) { },
    // 获取OSS参数
    getOssKey () {
      this.$http
        .get(
          `${window.SITE_CONFIG['forumURL']}/alioss/sysossali/getAliOssToken`
        )
        .then((item) => {
          if (item.result.code === 0) {
            this.bucketName = item.result.bucketName
            this.accessKeyId = item.result.accessKeyId
            this.accessKeySecret = item.result.accessKeySecret
            this.stsToken = item.result.securityToken
            this.getAliTime = new Date(item.result.expiration)
            // this.multipartUpload()
            // this.putBlob()
          }
        })
        .catch(() => {
          this.subLoading = false
        })
    },
    // 上传
    // async uploadOss (file) {
    //   try {
    //     if (this.subLoading) {
    //       return false
    //     }
    //     let timeStamp = new Date().getTime()
    //     let _this1 = this
    //     let oldObj = `lclb/${timeStamp}/${file.file.name}`
    //     let objectName = oldObj.replace(/\+/g, '')
    //     this.subLoading = true
    //     if (this.getAliTime.getTime() < new Date().getTime()) {
    //       await this.getOssKey()
    //     }
    //     await new OSS({
    //       region: `oss-cn-hangzhou`,
    //       accessKeyId: `${this.accessKeyId}`,
    //       accessKeySecret: `${this.accessKeySecret}`,
    //       bucket: `${this.bucketName}`,
    //       stsToken: `${this.stsToken}`
    //     }).multipartUpload(`${objectName}`, file.file, {
    //       progress: async function (p, checkpoint) {
    //       // 断点记录点。 浏览器重启后无法直接继续上传，需用户手动触发进行设置。
    //         // console.log(p, checkpoint)
    //         _this1.progress = parseInt(p * 100)
    //         _this1.p = p
    //         // file.percentage(p)
    //         file.onProgress({percent:parseInt(p * 100)})
    //         // e.percent
    //         // this.tempCheckpoint = checkpoint
    //         if (p === 1) {
    //           // console.log(p, checkpoint)
    //           _this1.getVideoOssId(objectName, file, checkpoint)
    //         }
    //       }
    //     })
    //   } catch (e) {
    //     this.subLoading = false
    //     // console.log(e)
    //     file.onError(file)
    //     this.$message.warning('上传失败，请重新上传')
    //   }
    // },
    // getVideoOssId (objectName, file, checkpoint) {
    //   this.$http.post(`${window.SITE_CONFIG['forumURL']}/alioss/sysossali/aliOssUploadDemandAttachment`, {
    //     objectName: objectName,
    //     fileName: file.file.name,
    //     fileSize: file.file.size.toString()
    //   })
    //   .then(data => {
    //     if (data.result && data.result.code === 0) {
    //       this.fileListS.push({
    //         uid: file.file.uid,
    //         ossId: data.result.aliOssId,
    //         ossName: objectName,
    //         name:file.file.name
    //         // uploadId: checkpoint.uploadId
    //       })
    //     } else {
    //       file.onError(file)
    //     }
    //     this.subLoading = false
    //   })
    //   .catch(error => {
    //     file.onError(file)
    //     this.subLoading = false
    //   })
    // },
    // 页面关闭时清理OSS文件
    deleteOssId () {
      let deleteIds = []
      if (this.subFlag) {
        deleteIds = this.delUrls
      } else {
        deleteIds = this.fileListS
          .filter((item) => {
            return !item.save
          })
          .map((item) => {
            return item.ossId
          })
      }
      if (deleteIds.length) {
        deleteIds.forEach((item) => {
          this.$http.post(
            `${window.SITE_CONFIG['forumURL']}/alioss/sysossali/deleteAliOss/${item}`
          )
        })
      }
      window.removeEventListener('beforeunload', this.deleteOssId)
    },
    getSummaries (param) {
      const { columns } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 10) {
          sums[index] = '应付金额'
          return
        }
        if (index === 11) {
          // const values = data.map((item) => Number(item[column.property]))
          // if (!values.every(value => isNaN(value))) {
          //     sums[index] = values.reduce((prev, curr) => {
          //       const value = Number(curr)
          //       if (!isNaN(value)) {
          //         return prev + curr
          //       } else {
          //         return prev
          //       }
          //     }, 0)
          //     sums[index] += ' 元'
          //   } else {
          //     sums[index] = 'N/A'
          //   }
          sums[11] = this.arAmount + ' 元'
        }
      })
      // if (sums[11]){
      //    var sumsall = Number(sums[11].split(' ')[0]).toFixed(2)
      //    sumsall = sumsall.toString() + ' 元'
      //    sums[11] = sumsall
      // }

      return sums
    },
    handleReject () {
      this.visible = true
    },
    cancelAdd () {
      this.visible = false
      this.dataForm.remark = ''
    },
    handleCancel () {
      var flag = true
      if (
        this.dataForm.remarkReason === '' ||
        this.dataForm.remarkReason === null ||
        this.dataForm.remarkReason === undefined
      ) {
        this.$message.error('请填写驳回原因')
        flag = false
      }
      var billId = this.detailInfo.billId
      if (flag) {
        this.subLoading = true
        this.$http
          .post(`/front/order/lclb/accountbill/reject`, {
            billId: billId,
            content: this.dataForm.remarkReason
          })
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message({
                message: '驳回成功',
                type: 'success',
                duration: 1500
              })
              this.visible = false
              this.dataForm.remarkReason = ''
              this.subLoading = false
              this.getInfo()
            } else {
              this.subLoading = false
            }
          })
          .catch(() => {
            this.subLoading = false
          })
      }
    },
    // 确认对账单
    handleSave () {
      var billId = this.detailInfo.billId
      if (this.subLoading) {
        return false
      }
      this.subLoading = true
      this.$http
        .post(`/front/order/lclb/accountbill/confirmBill`, {
          billId: billId
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message({
              message: '确认成功',
              type: 'success',
              duration: 1500
            })
            this.subLoading = false
            this.getInfo()
          } else {
            this.subLoading = false
          }
        })
    },
    // 确认支付
    handleCheck () {
      var flag = true
      var billId = this.detailInfo.billId
      if (this.subLoading) {
        return false
      }
      if (this.fileListS.length === 0) {
        this.$message.error('请上传支付凭证')
        flag = false
        return false
      }
      // console.log(this.fileListS)
      let voucherOssRelations = this.fileListS.map((item) => {
        return { aliOssId: item.ossId }
      })
      // console.log(voucherOssRelations)
      if (flag) {
        this.subLoading = true
        this.$http
          .post(`${window.SITE_CONFIG['baseURL']}/lclb/accountbill/confirmed`, {
            billId: billId,
            voucherOssRelations: voucherOssRelations
          })
          .then((data) => {
            if (data.result.code === 0) {
              this.$message({
                message: '确认支付成功',
                type: 'success',
                duration: 1500
              })
              this.subLoading = false
              this.getInfo()
            } else {
              this.subLoading = false
            }
          })
          .catch(() => {
            this.subLoading = false
          })
      }
    },
    // 支付
    handlePay () {
      var billId = this.detailInfo.billId
      // this.$message.warning('支付功能即将上线，敬请期待')
      this.$router.push({
        name: 'spareOrderPay',
        params: { id: billId, money: this.arAmount }
      })
      sessionStorage.setItem('billId', billId)
      sessionStorage.setItem('pay', this.arAmount)
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-input.is-disabled .el-input__inner {
  color: #000;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #000;
}
.tabletitle,
.tablefoot {
  height: 50px;
  line-height: 50px;
  width: 100%;
  margin-top: 10px;
  box-sizing: border-box;
}
.tabletitle div {
  float: left;
  background: #eeeeee;
  font-weight: bold;
  padding-left: 20px;
  box-sizing: border-box;
}
.activeOne {
  height: 90px !important;
}
.activeTwo {
  height: 180px !important;
}
.activeThree {
  height: 270px !important;
}
.activeOne2 {
  height: 90px !important;
  line-height: 89px;
}
.activeTwo2 {
  height: 180px !important;
  line-height: 179px;
}
.activeThree2 {
  height: 270px !important;
  line-height: 269px;
}
.body-info h2 {
  font-size: 20px;
  color: #262626;
  margin-bottom: 20px;
}
.body-info {
  margin: 20px 0;
  width: 100%;
  padding: 30px 30px;
  background-color: #fff;
  word-wrap: break-word;
  word-break: break-all;
}
.btns {
  display: flex;
  justify-content: center;
}
.row-opt-but {
  width: 161px;
  height: 50px;
  border: 1px solid #1d65a8;
  background-color: #fff;
  color: #1d65a8;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}
.row-opt-but:hover {
  background-color: #1d65a8;
  color: #fff;
}
.btn-check-cancel:hover {
  background-color: #1d65a8;
  color: #fff;
}
.but-loading {
  opacity: 0.5;
  cursor: not-allowed;
}
.inquiryfj {
  padding-left: 8px;
}
.inquiryfj li {
  width: 600px;
  height: 50px;
  position: relative;
  cursor: pointer;
}
.inquiryfjx {
  position: absolute;
  right: 0px;
  top: 0;
  width: 20px;
  height: 20px;
}
.inquiryfj li img {
  width: 40px;
  height: 40px;
  float: left;
}
.inquiryfj li p {
  text-align: left;
  font-size: 14px;
  line-height: 40px;
  color: #333333;
  font-weight: bold;
  width: 450px;
  height: 40px;
  text-indent: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  float: left;
  white-space: nowrap;
}
.removePic {
  right: -16px;
  top: -25px;
  cursor: pointer;
}
.inquiryfj li i {
  font-size: 95px;
  cursor: pointer;
}
.btn-check {
  margin-left: 30px;
}
.addressList {
  list-style: none;
}
.addTitle {
  height: 80px;
  line-height: 80px;
  font-size: 22px;
  color: #333333;
  text-indent: 8px;
  border-bottom: 1px solid #eeeeee;
}
.addTitle1 {
  flex: 1;
  font-size: 16px;
  color: #666666;
  line-height: 44px;
}

.addTitle2 {
  width: 130px;
  height: 40px;
  box-sizing: border-box;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  user-select: none;
  cursor: pointer;
  z-index: 666;
}
.addList {
  margin-bottom: 30px;
}

.addList li {
  height: 98px;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  user-select: none;
}

.addListInfo {
  flex: 1;
  padding-top: 23px;
  padding-bottom: 23px;
  padding-left: 10px;
}

.addListInfo1 {
  height: 16px;
  line-height: 16px;
  font-size: 16px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 18px;
}

.addListInfo1 span {
  display: inline-block;
  width: 35px;
  height: 20px;
  line-height: 20px;
  background: #1d65a8;
  color: #ffffff;
  font-weight: normal;
  font-size: 12px;
  text-align: center;
  margin-left: 20px;
  transform: scale(0.8) translateY(-2px);
}
.addListInfo2 {
  font-size: 14px;
  height: 18px;
  line-height: 18px;
  color: #333333;
}
.addListInfo22 {
  display: inline-block;
  vertical-align: middle;
  width: 14px;
  height: 18px;
  background: url(data:image/png;base64,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)
    no-repeat;
  background-size: 14px 18px;
  margin: 0 14px 0 0;
}
.two-btns {
  margin-bottom: 10px;
}
.spareInfo {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 10px;
}
.inqueryDetail {
  .el-textarea {
    width: 100%;
    min-width: 500px;
  }
  .good-link {
    cursor: pointer;
    color: #1d65a8;
    text-decoration: underline;
  }
  /deep/ .el-form-item__label {
    flex-grow: 0;
    flex-shrink: 0;
  }
  /deep/ .el-form--inline .el-form-item,
  .el-form--inline .el-form-item__content {
    display: flex;
    word-break: break-all;
    word-wrap: break-word;
  }
}
.row-height {
  height: 35px;
}
.tabs {
  height: 48px;
  margin: 0 69px;
}
.tab-item {
  display: inline-block;
  /* padding: 12px 16px; */
  text-align: center;
  background: #ffffff;
  /* box-shadow: inset 0 -1px 0 0 #DDDDDD; */
  /* width: 88px; */
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  letter-spacing: 0;
  margin-right: 24px;
  cursor: pointer;
}
.tab-item-active {
  color: #1d65a8;
  border-bottom: 2px solid #1d65a8;
}
.tab-item-content {
  padding-top: 10px;
}
// 评价
.box-shadow {
  padding: 40px;
}
.comment-left {
  width: 246px;
  height: 80px;
  float: left;
}
.comment-right {
  float: left;
  height: 80px;
  width: 800px;
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
  align-items: center;
}
.commnet-top {
  height: 90px;
}
.submit-btn {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.comment-bottom {
  height: 120px;
}
.bottom-left {
  float: left;
  width: 80px;
}
.bottom-right {
  float: left;
  width: 938px;
}
.comment-left img {
  width: 60px;
  height: 60px;
  float: left;
  margin-right: 20px;
}
.com-one {
  font-size: 18px;
  color: #333;
  font-weight: bold;
  margin: 5px 0;
}
.com-new {
  margin-top: 15px;
  margin-bottom: 0px;
}
</style>
